const menuManage = () => import('@/view/mall/menu-manage'); //菜单设置
const currencySetting = () => import('@/view/mall/currency-setting'); //参数设置
const labelSetting = () => import('@/view/mall/label-setting'); //标签设置
const labelItem = () => import('@/view/mall/label-item'); //标签设置
const banner = () => import('@/view/mall/banner'); //轮播图设置
const shareSetting = () => import('@/view/mall/share-setting'); //分享设置
const agreementManage = () => import('@/view/mall/agreement-manage'); //协议文案设置
const agreement = () => import('@/view/mall/agreement'); //协议文案设置
const officialAccount = () => import('@/view/mall/official-account'); //协议文案设置
const feedback = () => import('@/view/mall/feedback'); //
const feedbackDetail = () => import('@/view/mall/feedback-detail'); //
const hot = () => import('@/view/mall/hot'); //
const hotspot = () => import('@/view/mall/hotspot'); //

const freight = () => import('@/view/mall/freight'); //运费模板设置
const liveList = () => import('@/view/mall/live-list'); //运费模板设置
const questionTip = () => import('@/view/mall/question-tip'); //运费模板设置
// const shareSetting = () => import('@/view/mall/share-setting');  

export default [{
    path: '/menu-manage',
    name: 'menuManage',
    component: menuManage
}, {
    path: '/currency-setting',
    name: 'currencySetting',
    component: currencySetting
}, {
    path: '/label-setting',
    name: 'labelSetting',
    component: labelSetting
}, {
    path: '/label-item',
    name: 'labelItem',
    component: labelItem
}, {
    path: '/banner',
    name: 'banner',
    component: banner
}, {
    path: '/share-setting',
    name: 'shareSetting',
    component: shareSetting
}, {
    path: '/banner',
    name: 'banner',
    component: banner
}, {
    path: '/agreement-manage',
    name: 'agreementManage',
    component: agreementManage
},{
    path: '/agreement',
    name: 'agreement',
    component: agreement
}, {
    path: '/official-account',
    name: 'officialAccount',
    component: officialAccount
}, {
    path: '/feedback',
    name: 'feedback',
    component: feedback
}, {
    path: '/feedback-detail',
    name: 'feedbackDetail',
    component: feedbackDetail
}, {
    path: '/hot',
    name: 'hot',
    component: hot
}, {
    path: '/hotspot',
    name: 'hotspot',
    component: hotspot
}, {
    path: '/freight',
    name: 'freight',
    component: freight
}, {
    path: '/live-list',
    name: 'liveList',
    component: liveList
}, {
    path: '/question-tip',
    name: 'questionTip',
    component: questionTip
}];